import React from 'react'
import PropTypes from 'prop-types'
import DateTime from '../DateTime'
import './style.css'
import moment from "moment";



const DateInterval = props => {
    const { startDate, endDate, startTime, endTime } = props

  //  const hasData = !!startDate || !!endDate || !!startTime || !!endTime
    const hasBothDates = !!startDate && !!endDate
    const hasBothTimes = !!startTime && !!endTime
    const sameDate = moment(startDate).startOf('day').diff( moment(endDate).startOf('day'), 'days') === 0
    const hasTime = !!startTime || !!endTime

    return (
        <div className={'nrt-date-interval'} style={{ display: 'flex' }}>
            {
                !!startDate && <DateTime date={startDate} />

            }

            {
                hasBothDates &&
                !sameDate && <span className="date-interval-text"> à </span>
            }


            {
                !!endDate &&
            !sameDate &&
                <DateTime date={endDate} />
            }


            {
                hasTime && <span className="separator"> | </span>
            }

            {
                !!startTime &&
            <span className="time-interval-text">{startTime}</span>
            }

            {
                hasBothTimes &&
                <span className="time-interval-text"> às </span>
            }

            {
                !!endTime &&
                <span className="time-interval-text">{endTime}</span>
            }
        </div>
    )
}

DateInterval.propTypes = {
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    startTime: PropTypes.string,
    endTime: PropTypes.string
}

export default DateInterval



// WEBPACK FOOTER //
// ./src/components/_common/DateInterval/index.js